var Distro = {
    resetErrors: function() {
        $.each($('input'), function(key, value) {
            if ($(this).hasClass('border-red-800')) {
                $(this).removeClass('border-red-800').addClass('border-gray-700');
                $(this).parent().find('span').hide();
                $('#messageDiv').removeClass('bg-red-800').removeClass('bg-green-800').hide();
            }
        });
        $.each($('select'), function(key, value) {
            if ($(this).hasClass('border-red-800')) {
                $(this).removeClass('border-red-800').addClass('border-gray-700');
                $(this).parent().parent().find('span').hide();
                $('#messageDiv').removeClass('bg-red-800').removeClass('bg-green-800').hide();
            }
        });
    },
    checkInputs: function() {
        let name = $('#name').val().length;
        let location = $('#location').val().length;
        let url = $('#url').val().length;
        let uid = $('#uid').val().length;
        let country = $('#country').val().length;

        if (name > 0 && location > 0 && url > 0 && uid > 0 
            && country > 0) {
            return true;
        } else {
            return false;
        }
    },
    checkEditInputs: function() {
        let name = $('#name').val().length;
        let location = $('#location').val().length;
        let url = $('#url').val().length;
        let uid = $('#uid').val().length;
        let id = $('#id').val().length;
        let approved = $('#approved').val().length;
        let country = $('#country').val().length;
        if (name > 0 && location > 0 && url > 0 && uid > 0 && id > 0 && approved > 0 
            && country > 0) {
            return true;
        } else {
            return false;
        }
    },
    addDistro: function() {
        this.resetErrors();
        this.addDistroPromise()
            .then((response) => {
                $('#messageDiv').addClass('bg-green-800').show();
                $('#message').html('Thank you for submitting ' + response.data.name + ' to the Codex.  We will review your submission as soon as possible.');
            })
            .catch((error) => {
                //console.log(error.response);
                let message = error.response.data.message;
                $('#message').text(message);
                $('#messageDiv').removeClass('bg-green-800').addClass('bg-red-800').show();

                $.each(error.response.data.errors, function(key, value) {
                    //console.log("key = " + key);
                    //console.log("value = " + value);
                    let messageText = '#' + key + "Error";
                    $(messageText).text(value).show();
                    if ($('#' + key).hasClass('border-gray-700')) {
                        $('#' + key).removeClass('border-gray-700').addClass('border-red-800');
                    }
                    
                });
            });
    },
    addDistroPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.name = $('#name').val();
            request.location = $('#location').val();
            request.url = $('#url').val();
            request.uid = $('#uid').val();
            request.country = $('#country').val();

            let formData = new FormData();
            let logoFile = document.getElementById('logo').files[0];

            if (document.getElementById('logo').files.length > 0)
                formData.append("logo", logoFile, logoFile.name);

            formData.append("name", request.name);
            formData.append("location", request.location);
            formData.append("url", request.url);
            formData.append("uid", request.uid);
            formData.append("country", request.country);

            window.axios.post('/submit/distro', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    },
    editDistro: function() {
        this.resetErrors();
        this.editDistroPromise()
            .then((response) => {
                $('#messageDiv').addClass('bg-green-800').show();
                $('#message').html(response.data.name + ' has been edited.');
            })
            .catch((error) => {
                //console.log(error);
                //console.log(error.response);
                let message = error.response.data.message;
                $('#message').text(message);
                $('#messageDiv').removeClass('bg-green-800').addClass('bg-red-800').show();

                $.each(error.response.data.errors, function(key, value) {
                    //console.log("key = " + key);
                    //console.log("value = " + value);
                    let messageText = '#' + key + "Error";
                    $(messageText).text(value).show();
                    if ($('#' + key).hasClass('border-gray-700')) {
                        $('#' + key).removeClass('border-gray-700').addClass('border-red-800');
                    }
                    
                });
            });
    },
    editDistroPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.name = $('#name').val();
            request.location = $('#location').val();
            request.url = $('#url').val();
            request.uid = $('#uid').val();
            request.id = $('#id').val();
            request.approved = $('#approved').val();
            request.country = $('#country').val();

            let formData = new FormData();
            let logoFile = document.getElementById('logo').files[0];

            if (document.getElementById('logo').files.length > 0)
                formData.append("logo", logoFile, logoFile.name);

            formData.append("name", request.name);
            formData.append("location", request.location);
            formData.append("url", request.url);
            formData.append("uid", request.uid);
            formData.append("id", request.id);
            formData.append("approved", request.approved);
            formData.append("country", request.country);

            window.axios.post('/curator/distro/edit', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    }
}

$(document).ready(function() {
    // click add distro
    $('#submitDistro').on('click', function() {
        // check inputs
        if (!Distro.checkInputs())
            return;
        Distro.addDistro();
    });
    // click edit distro
    $('#editDistro').on('click', function() {
        // check inputs
        if (!Distro.checkEditInputs())
            return;
        Distro.editDistro();
    });
});